import { useHomeNavigation } from "@/lib/useHomeNavigation";

export const BrandName = ({ placement }) => {
  const goHome = useHomeNavigation();
  return (
  <button
    type="button"
    onClick={() => goHome("#hero")}
    aria-label="EDUBRIDGE home"
    data-testid={`${placement}-brand-home-btn`}
    className={`inline-block font-sans font-extrabold tracking-normal text-frost transition-colors duration-300 hover:text-mint focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-mint ${
      placement === "footer" ? "text-2xl" : "text-xl"
    }`}
  >
    EDUBRIDGE
  </button>
  );
};